import { reactive } from 'vue'

export const notifyState = reactive({
  show: false,
  message: '',
  color: 'success',
  timeout: 2000,
})

const notify = {
  success({ message } = {}) {
    notifyState.message = message || 'sucesso'
    notifyState.color = 'success'
    notifyState.timeout = 2000
    notifyState.show = true
  },
  error({ title, message } = {}) {
    notifyState.message = message || title || 'erro'
    notifyState.color = 'error'
    notifyState.timeout = 5000
    notifyState.show = true
  },
}

export default {
  install(app) {
    app.config.globalProperties.$notify = notify
  },
}
